<div class="container">
  <div class="heading-container">
    <p class="heading">{{ title }}</p>
    <button class="close-btn" (click)="closed.emit()" aria-label="Close dialog">&times;</button>
  </div>

  <div class="modal-scroll">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
    <!-- Edge cues live OUTSIDE the scroller (absolutely positioned over its top/bottom),
         so they never affect content layout and are never clipped. Their opacity is
         driven by the scroller's position via the named scroll timeline below. -->
    <div class="modal-scroll__edge modal-scroll__edge--top" aria-hidden="true"></div>
    <div class="modal-scroll__edge modal-scroll__edge--bottom" aria-hidden="true"></div>
  </div>

  @if (errorMessage) {
    <div class="modal-error" role="alert">{{ errorMessage }}</div>
  }

  <div class="footer-actions">
    <app-buttons
      [buttonType]="'btn-mat-flat'"
      [buttonStyle]="'btn-text'"
      [name]="cancelLabel"
      (buttonClickEvent)="closed.emit()"
    ></app-buttons>
    <app-buttons
      [name]="primaryLabel"
      [buttonType]="'mat-flat-button'"
      [buttonStyle]="primaryDisabled ? 'btn-filled-small-disabled' : 'btn-filled-small'"
      [isDisabled]="primaryDisabled"
      (buttonClickEvent)="submitted.emit()"
    ></app-buttons>
  </div>
</div>
